/**
 * Konstanta layout halaman Demografi & Kependudukan.
 *
 * Angka-angka di sini hasil pengukuran DOM nyata di staging (lihat
 * `docs/qc/DEMOGRAFI-LAYOUT-PROPOSAL.md` §2.1), bukan tebakan. Yang paling
 * menentukan adalah **ambang ±30px ruang per kategori**: di bawah itu Recharts
 * membuang tick sumbu secara berselang tanpa indikasi apa pun, sehingga ada bar
 * yang tidak punya nama kategori.
 */

/**
 * Tinggi chart Row 2 (Pengelompokan Umur & Demografi Pekerjaan).
 *
 * Kartu Pekerjaan punya 10 kategori. Recharts memakai ±40px untuk sumbu-X dan
 * margin, jadi area plot = tinggi − 40. Pada 250px lamanya: (250−40)/10 = 21px
 * per kategori → 5 dari 10 label dibuang. Pada 340px: (340−40)/10 = 30px → semua
 * tampil. Dinaikkan bersamaan untuk kedua kartu agar tinggi Row 2 seragam.
 */
export const ROW2_CHART_HEIGHT = 340;

/**
 * Tinggi kartu Row 3 (Distribusi Agama, Data per Banjar, Sektor Unggulan).
 *
 * Tanpa patokan, ketiga kolom ikut kartu tertinggi (Data per Banjar, 553px di
 * 1440px dan 715px di 1280px) sehingga Sektor Unggulan menyisakan 244–406px
 * ruang kosong. Dipatok supaya tinggi tidak lagi ditentukan tetangga. Hanya
 * aktif dari breakpoint `lg` ke atas — di bawah itu kartu menumpuk dan tinggi
 * alami justru lebih enak dibaca.
 */
export const ROW3_CARD_HEIGHT = 440;

/** Lebar minimum viewport tempat tinggi Row 3 mulai dipatok (breakpoint `lg` Mantine). */
export const ROW3_FIXED_HEIGHT_MIN_WIDTH = "62em";

/**
 * Ruang kanan untuk `<LabelList position="right">`.
 *
 * Tanpa ini, label nilai bar terpanjang jatuh di luar `<svg>` dan terpotong —
 * terbukti pada nilai `570` di kartu Pekerjaan yang terbaca `57`.
 */
export const BAR_VALUE_MARGIN_RIGHT = 40;

/** Lebar kolom label kategori pada bar chart horizontal. */
export const JOB_AXIS_WIDTH = 150;
export const SECTOR_AXIS_WIDTH = 130;

/**
 * Tinggi minimum chart Sektor Unggulan. Chart-nya memakai `height="100%"` agar
 * mengisi sisa tinggi kartu; minimum ini menjaganya tetap terbaca saat tinggi
 * kartu belum dipatok (mobile/tablet) dan mencegah render 0px bila parent
 * kehilangan tinggi.
 */
export const SECTOR_CHART_MIN_HEIGHT = 250;

/**
 * Ambang potong label kategori. Dinaikkan dari 14/16 agar nama yang wajar tampil
 * utuh: `Belum/Tidak Bekerja` (19) dan `Kerajinan Genteng` (17) sebelumnya kena
 * potong padahal ruangnya ada. Yang tetap melewati ambang diberi `<title>` SVG
 * supaya teks penuhnya bisa dilihat saat hover.
 */
export const JOB_LABEL_MAX_CHARS = 22;
export const SECTOR_LABEL_MAX_CHARS = 20;

/**
 * Rotasi label sumbu-X kartu umur. Label seperti `25-54` butuh ±34px lebar,
 * sementara di 1280px hanya tersedia ±25px per kategori → 4 dari 8 label dibuang.
 * Dimiringkan agar tidak lagi bersaing secara horizontal.
 */
export const AGE_AXIS_ANGLE = -30;
export const AGE_AXIS_HEIGHT = 50;

/** Tinggi donut Distribusi Agama saat tinggi kartu belum dipatok (mobile/tablet). */
export const RELIGION_DONUT_MIN_HEIGHT = 200;

/**
 * Ringkasan pertumbuhan bersih di kartu Dinamika Penduduk. Jarak antar baris
 * dibuat rapat dan keterangan rumusnya lebih kecil dari labelnya, supaya blok
 * ini terbaca sebagai catatan kaki dari empat kotak di atasnya — bukan sebagai
 * kelompok metrik baru yang setara.
 */
export const NET_ROW_GAP = 6;
export const NET_HINT_FONT_SIZE = 10;
